import * as Yup from "yup"

const schema = Yup.object({
  limit: Yup.string().required(),
})

export default schema
